const MEETINGS_DEFAULTS = {
  pageTitle: 'Meetings',
  pageSubtitle: 'Schedule and manage your meetings',
  pageIcon: 'LuVideo',
  scheduleButtonLabel: 'Schedule Meeting',
  loadingMessage: 'Loading meetings...',
  upcomingTabLabel: 'Upcoming',
  ongoingTabLabel: 'Ongoing',
  pastTabLabel: 'Past',
  emptyUpcomingTitle: 'No upcoming meetings',
  emptyOngoingTitle: 'No ongoing meetings',
  emptyPastTitle: 'No past meetings',
  emptyScheduleButtonLabel: 'Schedule a Meeting',
  joinMeetingLabel: 'Join Meeting',
  durationSuffix: 'mins',
  modalTitle: 'Schedule New Meeting',
  modalSubtitle: 'Pick a convenient time and invite an admin to join your call.',
  titleFieldLabel: 'Meeting Title *',
  titlePlaceholder: 'Enter meeting title',
  descriptionFieldLabel: 'Description',
  descriptionPlaceholder: 'Share context for this meeting (optional)',
  datetimeFieldLabel: 'Start Date & Time *',
  datetimeHint: '(Mon–Fri, 5:00 PM – 8:00 PM IST only)',
  durationNote: 'Duration: 30 minutes (fixed)',
  istEquivalentLabel: 'IST Equivalent:',
  cancelButtonLabel: 'Cancel',
  createButtonLabel: 'Create Meeting',
  creatingButtonLabel: 'Creating...',
  weekdayError: 'Meetings can only be scheduled Monday to Friday (IST)',
  timeWindowError: 'Meetings can only be scheduled between 5:00 PM and 8:00 PM IST (Indian Standard Time)',
  createSuccessMessage: 'Meeting created successfully! Notification sent to admin.',
  createErrorMessage: 'Failed to create meeting. Please try again.',
};

export const getMeetingsPageMeta = (content) => ({
  ...MEETINGS_DEFAULTS,
  ...(content || {}),
});

export const getMeetingsTabLabel = (meta, tab) => {
  if (tab === 'upcoming') return meta.upcomingTabLabel;
  if (tab === 'ongoing') return meta.ongoingTabLabel;
  if (tab === 'past') return meta.pastTabLabel;
  return tab;
};

export const getMeetingsEmptyTitle = (meta, tab) => {
  if (tab === 'upcoming') return meta.emptyUpcomingTitle;
  if (tab === 'ongoing') return meta.emptyOngoingTitle;
  if (tab === 'past') return meta.emptyPastTitle;
  return `No ${tab} meetings`;
};
